import { render, staticRenderFns } from "./ExportsIndex.vue?vue&type=template&id=150c1766&scoped=true"
import script from "./ExportsIndex.vue?vue&type=script&lang=js"
export * from "./ExportsIndex.vue?vue&type=script&lang=js"
import style0 from "./ExportsIndex.vue?vue&type=style&index=0&id=150c1766&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150c1766",
  null
  
)

export default component.exports